<template>
  <b-dropdown
    variant="primary"
    toggle-class="btn btn-light-primary font-weight-bolder px-5 mr-2"
  >
    <template #button-content>
      <span class="svg-icon svg-icon-md">
        <inline-svg src="media/svg/icons/Design/PenAndRuller.svg" />
      </span>
      Exportar
    </template>
    <div class="navi navi-hover min-w-md-200px">
      <b-dropdown-text tag="div" class="navi-header pb-1">
        <span class="text-primary text-uppercase font-weight-bold font-size-sm">
          Escolha uma opção:
        </span>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item">
        <a class="navi-link" href="#">
          <span class="navi-icon"><i class="la la-print"></i></span>
          <span class="navi-text">Imprimir</span>
        </a>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item">
        <a class="navi-link" href="#">
          <span class="navi-icon">
            <i class="la la-file-excel-o"></i>
          </span>
          <span class="navi-text">Excel</span>
        </a>
      </b-dropdown-text>
    </div>
  </b-dropdown>
</template>

<style lang="scss">
.dropdown-menu {
  outline: none;
}
.b-dropdown-text {
  padding: 0;
}
</style>

<script>
export default {
  name: "exportar",
  components: {},
  mounted() {}
};
</script>
